export default __webpack_public_path__ + "static/media/bg3.e4ffd7e2.jpg";